import { RetornoVerificaRetificacaoTO } from "src/app/pagamento/models/retorno-verifica-retificacao-to";

export const RETORNO_VERIFICA_RETIFICACAO_CPF_SIMPLIFICADA_MOCK: RetornoVerificaRetificacaoTO = {
  "codigoRetorno": 0, 
  "mensagemRetorno": "", 
  "podeFazerRetificacao": true, 
  "podeRetificarPABase2": false, 
  "periodoApuracaoBase2": null, 
  "camposAlteraveis": [ 
    { "nomeCampo": "processo", "alteravel": false, "valor": null }, 
    { "nomeCampo": "origemErro", "alteravel": false, "valor": 2 }, 
    { "nomeCampo": "processoAlteracao", "alteravel": false, "valor": null }, 
    { "nomeCampo": "ni", "alteravel": false, "valor": "03672686557" }, 
    { "nomeCampo": "dataArrecadacao", "alteravel": false, "valor": "2023-08-31" }, 
    { "nomeCampo": "codigoBanco", "alteravel": false, "valor": "104" }, 
    { "nomeCampo": "codigoAgencia", "alteravel": false, "valor": "0739" }, 
    { "nomeCampo": "valorTotal", "alteravel": false, "valor": 616.87 }, 
    { "nomeCampo": "periodoApuracao", "alteravel": true, "valor": "2022-12-31" }, 
    { "nomeCampo": "dataVencimento", "alteravel": true, "valor": "2023-07-31" }, 
    { "nomeCampo": "referencia", "alteravel": true, "valor": null }, 
    { "nomeCampo": "idCEF", "alteravel": false, "valor": null }, 
    { "nomeCampo": "codigoReceita01", "alteravel": true, "valor": "0211" }, 
    { "nomeCampo": "codigoReceita02", "alteravel": true, "valor": "3244" }, 
    { "nomeCampo": "codigoReceita03", "alteravel": true, "valor": "0641" }, 
    { "nomeCampo": "valorReceita01", "alteravel": true, "valor": 544.13 }, 
    { "nomeCampo": "valorReceita02", "alteravel": true, "valor": 55.66 }, 
    { "nomeCampo": "valorReceita03", "alteravel": true, "valor": 17.08 }, 
    { "nomeCampo": "vrba", "alteravel": true, "valor": null }, 
    { "nomeCampo": "vrbaPercentual", "alteravel": true, "valor": null } 
  ], 
  "podeAlterarCodReceitas": null 
};
